import React, { useEffect, useRef, useState } from "react";
import { HiUsers, HiUserAdd, HiOutlineClock, HiCheck, HiXCircle } from "react-icons/hi";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../ui/YhTable";
import YhInput from "../../../ui/YhInput";
import LeadStatCard from "../../../ui/LeadStatCard";
import YhModal from "../../../ui/YhModal";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../helpers/methods";
import CustomButton from "../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import AddNewTeam from "../../AllLeads/components/AddNewTeam/AddNewTeam";
import AddNewTeam2 from "../../AllLeads/components/customerProfile/customerView";
import {
  assignToMembers,
  changeAt,
  changeStage,
  deleteReminder,
  getAllForms,
  getAllStage,
  getAllTeamData,
  getAllTeamMembersData,
  getAllUsers,
  // getDownloadLeads,
  getDownloadLeadsExcle,
  getReminder,
  getReminderData,
  saveReminder,
} from "../../AllLeads/components/ShowAll/ShowAllService";
import notifiers from "../../../global/constants/NotificationConstants";
import CustomLoader from "../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../global/components/CustomRadioButton/CustomRadioButton";
import { store } from "../../../utils/store";
import { useSelector } from "react-redux";
import { selectActiveOrganizationId } from "../../../redux/authSlice";
import { ReactComponent as VerticalDotIcon } from "../../../assets/icons/verticalDot.svg";
import LeadDetailsComponent from "../../../global/components/sidePanel/leadDetail";
import {
  getAllSource,
  getRemark,
  saveRemark,
} from "../../MyLead/components/ShowAll/ShowAllService";
import { applyLicenseKey } from "../../../utils/License";
import dayjs, { Dayjs } from "dayjs";
import { getStage } from "../../MetaData/components/MetaList/components/LeadStageData/LeadStageListService";
import { getAllHierarchyMeta } from "../../MetaData/components/MetaList/components/CompanyHierarchyList/companyHierarchyService";

/** react-icons + React 19 type bridge */
type IconComp = React.ComponentType<{ size?: number; className?: string }>;
const UsersIcon = HiUsers as IconComp;
const UserAddIcon = HiUserAdd as IconComp;
const ClockIcon = HiOutlineClock as IconComp;
const CheckIconRi = HiCheck as IconComp;
const XCircleIcon = HiXCircle as IconComp;
const DownloadSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <path d="M7 10l5 5 5-5" />
    <path d="M12 15V3" />
  </svg>
);

const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ChevronSvg = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const CalendarSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

const EditSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const ShowAll = () => {
  const activeOrganizationId = useSelector(selectActiveOrganizationId) || "";
  interface Lead {
    [key: string]: string | number | null | undefined;
  }
  const privileges = store.getState().auth?.privileges || {};
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [addNewTeamDialog, setNewTeamDialog] = useState<any>({
    open: false,
    edit: false,
  });
  const [customerDetails, setCustomerDetails] = useState<any>({
    open: false,
    edit: false,
  });

  const [eventForEdit, setEventForEdit] = React.useState();
  const [userId, setUserId] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setdownloadLoading] = useState(false);
  const [response, setResponse] = useState<any>();
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [showSideBar, setShowSideBar] = useState(false);
  const [dynamicGridValue, setDynamicGridValue] = useState<any>();
  const [addinationalValue, setaddinationalValue] = useState<any>();
  const [leadOption, setLeadOption] = useState<any>([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [reminderStatus, setReminderStatus] = useState<any>("");
  const currentDateTime = new Date().toISOString().slice(0, 16);
  const [reminderData, setReminderData] = useState<any>({
    date: currentDateTime,
  });
  const [responseValuereminder, setResponseValuereminder] = useState<any>([]);
  const [formName, setFormName] = useState<any>([]);
  const [tableData, setTableData] = useState<any>([]);
  const [stageData, setStageData] = useState<any>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  const [responseValueremark, setResponseValueremark] = useState<any>([]);
  const [idForTeam, setIdForTeam] = useState<any>([]);
  const [idForMember, setIdForMember] = useState<any>([]);
  const [leadData, setLeadData] = useState<any>();
  const [openModal, setOpenModal] = useState<any>({
    name: "",
    data: {},
    open: false,
  });
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [metaData, setMetaData] = useState<any>({});
  const [stageSourse, setStageSourse] = useState<any>([]);
  const [remData, setRemData] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [stage, setStage] = useState<{ label: string; isParent: boolean } | any>(null);
  const [source, setSource] = useState<any>(null);
  const [formLead, setFormLead] = useState<any>([]);
  const [selectedDateRange, setSelectedDateRange] = useState<any>({});
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [anchorEDate, setAnchorEDate] = useState<null | HTMLElement>(null);
  const [formMenuOpen, setFormMenuOpen] = useState(false);
  const [sourceMenuOpen, setSourceMenuOpen] = useState(false);
  const [stageMenuOpen, setStageMenuOpen] = useState(false);
  const formMenuRef = useRef<HTMLDivElement>(null);
  const sourceMenuRef = useRef<HTMLDivElement>(null);
  const stageMenuRef = useRef<HTMLDivElement>(null);
  const dateMenuRef = useRef<HTMLDivElement>(null);
  const editPopoverRef = useRef<HTMLDivElement>(null);
  const [type, setType] = useState("");
  const [allSatgedata, setAllStagedata] = useState<any>([]);
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const [selectedRow, setSelectedRow] = useState<null | any>(null);
  const [hierarchyMap, setHierarchyMap] = useState<{ [key: string]: string }>(
    {}
  );
  const [reminders, setReminders] = useState<{ [key: string]: any }>({});
  useEffect(() => {
    applyLicenseKey();
  }, []);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (formMenuRef.current && !formMenuRef.current.contains(target)) {
        setFormMenuOpen(false);
      }
      if (sourceMenuRef.current && !sourceMenuRef.current.contains(target)) {
        setSourceMenuOpen(false);
      }
      if (stageMenuRef.current && !stageMenuRef.current.contains(target)) {
        setStageMenuOpen(false);
      }
      if (dateMenuRef.current && !dateMenuRef.current.contains(target)) {
        setOpenDatePicker(false);
        setAnchorEDate(null);
      }
      if (editPopoverRef.current && !editPopoverRef.current.contains(target)) {
        setAnchorEl(null);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      tableDataShowHandler();
    }, 40);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formLead, search, paginationModel, selectedDateRange, stage, source, activeOrganizationId]);


  const flattenStageData = (
    data: any[]
  ): { label: string; isParent: boolean }[] => {
    const result: { label: string; isParent: boolean }[] = [];

    const extractStageNames = (stages: any[]) => {

      stages.forEach((stage) => {
        if (stage.stage_Name) {
          result.push({ label: stage.stage_Name, isParent: true }); // Parent entry
        }
        if (stage.sub_Stage_name && Array.isArray(stage.sub_Stage_name)) {
          stage.sub_Stage_name.forEach((subStage: any) => {
            result.push({ label: subStage.stage_Name, isParent: false }); // Child entry
          });
        }
      });
    };

    extractStageNames(data);
    return result;
  };

  const stageOptions = flattenStageData(allSatgedata);

  const catalogLoaded = useRef(false);
  const loadArchiveCatalogs = () => {
    if (catalogLoaded.current) return;
    catalogLoaded.current = true;
    getAllStage()
      .then((response2) => {
        const val = (response2?.data || []).map((e: any) => e.status_name);
        setStageData(val?.filter((name: any) => name !== "Initial"));
      })
      .catch(() => undefined);
    getAllSource()
      .then((response32) => {
        setStageSourse((response32?.data || []).map((e: any) => e.source_name));
      })
      .catch(() => undefined);
    getAllForms()
      .then((response3) => {
        setFormName(
          (response3?.data || [])
            ?.filter((item: any) => item.status === "1")
            ?.map((i: any) => ({ id: i._id, label: i.form_name }))
        );
      })
      .catch(() => undefined);
    getStage()
      .then((resData) => setAllStagedata(resData?.data || []))
      .catch(() => undefined);
    getAllHierarchyMeta()
      .then((response) => {
        const hierarchyData = (response?.data || []).reduce((acc: any, e: any) => {
          acc[e._id] = e.hierarchyName;
          return acc;
        }, {});
        setHierarchyMap(hierarchyData);
      })
      .catch(() => undefined);
  };

  const handlePageSizeChange = (event: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: event.target.value,
      page: 0,
    });
  };
  const handleDateRangeChange = (newDateRange: any) => {
    if (newDateRange[0] === null && newDateRange[1] === null) {
      setOpenDatePicker(false);
      setAnchorEDate(null);
      setSelectedDateRange({ from: null, to: null });
    } else {
      const from = newDateRange[0]?.format("DD-MM-YYYY");
      const to = newDateRange[1]?.format("DD-MM-YYYY");
      if (from && to) {
        setOpenDatePicker(false);
        setAnchorEDate(null);
        setSelectedDateRange({ from, to });
      }
    }
  };


  const shortcutsItems: { label: string; getValue: () => [Dayjs | null, Dayjs | null] }[] = [
    {
      label: "This Week",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("week"), today.endOf("week")];
      },
    },
    {
      label: "Last Week",
      getValue: () => {
        const today = dayjs();
        const prevWeek = today.subtract(7, "day");
        return [prevWeek.startOf("week"), prevWeek.endOf("week")];
      },
    },
    // {
    //   label: "Last 7 Days",
    //   getValue: () => {
    //     const today = dayjs();
    //     return [today.subtract(7, "day"), today];
    //   },
    // },
    {
      label: "Current Month",
      getValue: () => {
        const today = dayjs();
        return [today.startOf("month"), today.endOf("month")];
      },
    },
    // {
    //   label: "Next Month",
    //   getValue: () => {
    //     const today = dayjs();
    //     const startOfNextMonth = today.endOf("month").add(1, "day");
    //     return [startOfNextMonth, startOfNextMonth.endOf("month")];
    //   },
    // },
    {
      label: "Last Month",
      getValue: () => {
        const today = dayjs();
        const startOfLastMonth = today.startOf("month").subtract(1, "month");
        const endOfLastMonth = startOfLastMonth.endOf("month");
        return [startOfLastMonth, endOfLastMonth];
      },
    },

    {
      label: "Last Year",
      getValue: () => {
        const today = dayjs();
        const prevYear = today.subtract(1, "year");
        return [prevYear.startOf("year"), prevYear.endOf("year")];
      },
    },
    { label: "Reset", getValue: () => [null, null] },
  ];

  const filterLeadByForm = async (value: any[]) => {
    setFormLead(value);
  };


  const onClickHandler = () => {
    setUserId("");
    setNewTeamDialog({
      open: true,
    });
  };

  const closeHandler = () => {
    setNewTeamDialog(false);
    setCustomerDetails(false);
  };
  const handelDropdown = async (id: any) => {
    setLoading(true);
    try {
      setApiResponse(true);
      const response1 = await getAllTeamData(id?.id);
      const assignToData = response1.data.flatMap((team: any) => {
        const subTeams =
          team.sub_teams?.map((subTeam: any) => ({
            id: subTeam._id,
            label: subTeam.team_name,
            selected: subTeam?.is_available,
            isParent: false,
            teamMembers: subTeam.team_members.length
              ? subTeam.team_members.map((member: any) => {
                return {
                  id: member.userId,
                  label: member.users[0].name,
                  selected: 0,
                };
              })
              : null,
          })) || [];

        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent: true,
          teamMembers: team.team_members.length
            ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
            : null,
        };
        return [mainTeam, ...subTeams];
      });
      setLeadOption(assignToData);

      const selectedData = assignToData
        .filter((e: any) => {
          return e?.selected == 1;
        })
        .map((e: any) => {
          return {
            id: e.id,
            label: e.label,
            selected: e?.selected,
            teamMembers: Array.isArray(e.teamMembers)
              ? e.teamMembers.map((member: any) => ({
                id: member.id,
                label: member.label,
                selected: 0,
              }))
              : null,
          };
        });

      setSelectedOptions(selectedData);

      const ids = assignToData
        .filter((e: any) => e?.selected === 1)
        .map((e: any) => e.id);
      if (ids) {
        handelDropdownAfterSelect(ids, id);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    } finally {
      setApiResponse(false);
      setLoading(false);
    }
  };

  const openCustomer = (params: any) => {
    setUserId(params._id);
    setLeadData(params.row);
    setCustomerDetails({
      open: true,
    });
    getReminderInfo(params._id);
    getRemarkInfo(params._id);
    setType(params.type);
  };

  const handleEdit = (id: string) => {
    setNewTeamDialog({
      open: true,
      edit: true,
    });
    setUserId(id);
  };

  // const handleCloseLoan = () => {
  //   setIsDialogOpenLoan(false);
  // };

  // const handleCloseLoanList = () => {
  //   setIsDialogOpenLoanList(false);
  // };

  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any,
    userData: any
  ) => {
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
    setEventForEdit(userData);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseModal = () => {
    setOpenModal({
      name: "",
      data: {},
      open: false,
    });
  };

  const getReminderInfo = async (id: any) => {
    try {
      setApiResponse(true);
      setLoading(true);
      const response = await getReminder(id);

      if (response.success == 1) {
        setResponseValuereminder((prevFormData: any) => ({
          ...prevFormData,
          value: response?.data,
        }));
      } else {
        setResponseValuereminder([]);
      }
      setLoading(false);
    } catch (error: any) {
      // openErrorNotification(
      //   isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      // );
      setLoading(false);
    } finally {
      setApiResponse(false);
      setLoading(false);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleRowClick = async (id: any) => {
    setShowSideBar(!showSideBar);
    setDynamicGridValue(id.row);
    setaddinationalValue(id?.row.dynamicFields || []);
    handelDropdown(id);
    getRemarkInfo(id?.id);
    getReminderInfo(id?.id);
  };

  const renderMenu = () => {
    if (!menuPosition) return null;
    return (
      <>
        <div
          className="fixed inset-0 z-40"
          onClick={() => {
            setMenuPosition(null);
            setSelectedRow(null);
          }}
        />
        <div
          className="fixed z-50 w-[220px] max-w-full rounded-yh-md border border-yh-border bg-white py-1 shadow-yh"
          style={{
            top: menuPosition.top,
            left: Math.max(0, menuPosition.left - 190),
          }}
        >
          <div className="cursor-default px-3 py-2 text-xs font-yh-bold text-yh-light-gray">
            Actions
          </div>
          <button
            type="button"
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-xs text-yh-black hover:bg-yh-lilac"
            onClick={() => {
              setNewTeamDialog({
                open: true,
                edit: true,
              });
              setEventForEdit(selectedRow);
              setUserId(selectedRow._id);
              setMenuPosition(null);
            }}
          >
            <EditSvg />
            Edit
          </button>
        </div>
      </>
    );
  };

  // Persist across renders — a new Set() every render re-fetches every row and freezes the page.
  const fetchedReminderIds = useRef<Set<string>>(new Set());

  const fetchReminder = async (id: string) => {
    if (!id || fetchedReminderIds.current.has(id)) return;
    fetchedReminderIds.current.add(id);
    try {
      const reminder = await getReminder(id);
      setReminders((prev) => ({ ...prev, [id]: reminder?.data ?? [] }));
    } catch {
      setReminders((prev) => ({ ...prev, [id]: [] }));
    }
  };

  useEffect(() => {
    (userDataSource1 || []).forEach((row: any) => {
      const leadId = row?._id;
      if (leadId && !fetchedReminderIds.current.has(leadId)) {
        fetchReminder(leadId);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDataSource1]);

  const columns: YhTableColumn[] = [
    {
      headerName: "Lead",
      field: "leadName",
      minWidth: 220,
      renderCell: (params: YhTableCellParams) => {
        const name = params.row?.leadName || "?";
        const initial = String(name).trim().charAt(0).toUpperCase() || "?";
        const avatarPalette = [
          { bg: "#F9F0F4", color: "#6B1630" }, // purple
          { bg: "#DBEAFE", color: "#2563EB" }, // blue
          { bg: "#D1FAE5", color: "#059669" }, // green
          { bg: "#FFEDD5", color: "#EA580C" }, // orange
          { bg: "#FEF3C7", color: "#D97706" }, // amber
          { bg: "#FCE7F3", color: "#DB2777" }, // pink
          { bg: "#CCFBF1", color: "#0D9488" }, // teal
        ];
        let hash = 0;
        for (let i = 0; i < String(name).length; i++) {
          hash = String(name).charCodeAt(i) + ((hash << 5) - hash);
        }
        const avatar = avatarPalette[Math.abs(hash) % avatarPalette.length];

        return (
          <div
            className="action-button flex cursor-pointer items-center gap-3"
            data-action-button="true"
            onClick={() => {
              openCustomer(params.row);
              setLeadData(params.row);
            }}
          >
            <span
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-sm font-bold"
              style={{ backgroundColor: avatar.bg, color: avatar.color }}
            >
              {initial}
            </span>
            <div className="min-w-0 flex flex-col items-start gap-0.5">
              <span className="truncate text-sm font-semibold capitalize text-[#111827]">
                {name}
              </span>
              <span className="text-xs text-[#9CA3AF]">{params.row?.uid}</span>
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Property",
      field: "project_name",
      minWidth: 180,
      renderCell: (params: YhTableCellParams) => (
        <div className="flex min-w-0 flex-col items-start gap-0.5">
          <span className="truncate text-sm font-semibold capitalize text-[#111827]">
            {params.row.project_name || "—"}
          </span>
          <span className="truncate text-xs capitalize text-[#6B7280]">
            {params.row.developer_name || ""}
          </span>
        </div>
      ),
    },
    {
      headerName: "Priority",
      field: "priority",
      minWidth: 110,
      renderCell: (params: YhTableCellParams) => {
        const priority = params.row?.priority;
        const priorityLabel =
          priority === 1 ? "High" : priority === 2 ? "Medium" : priority === 3 ? "Low" : "—";
        const priorityClass =
          priority === 1
            ? "bg-red-50 text-red-600"
            : priority === 2
            ? "bg-orange-50 text-orange-600"
            : priority === 3
            ? "bg-emerald-50 text-emerald-600"
            : "bg-[#F3F4F6] text-[#6B7280]";

        return (
          <span
            className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${priorityClass}`}
          >
            {priorityLabel}
          </span>
        );
      },
    },
    {
      headerName: "Type",
      field: "projecttype_name",
      minWidth: 140,
      renderCell: (params: YhTableCellParams) => (
        <span className="truncate text-sm capitalize text-[#374151]">
          {params.row.projecttype_name || "—"}
        </span>
      ),
    },
    {
      headerName: "Reminder",
      field: "reminder",
      minWidth: 120,
      renderCell: (params: YhTableCellParams) => {
        const leadId = params.row._id;
        const reminderData = reminders[leadId];

        if (reminderData && reminderData.length > 0) {
          const latestReminder = reminderData.reduce(
            (
              latest: { date: any; time: any },
              current: { date: any; time: any }
            ) => {
              const latestDateTime = new Date(`${latest.date}T${latest.time}`);
              const currentDateTime = new Date(
                `${current.date}T${current.time}`
              );
              return currentDateTime > latestDateTime ? current : latest;
            }
          );

          const reminderDateTimeString = `${latestReminder.date}T${latestReminder.time}`;
          const reminderDateTime = new Date(reminderDateTimeString);
          const currentDate = new Date();
          const isExpired = reminderDateTime < currentDate;

          return (
            <div className="flex flex-col items-start gap-1">
              {!isExpired ? (
                <span className="inline-flex h-7 items-center justify-center rounded-full border border-emerald-200 bg-emerald-50 px-2.5 text-[11px] font-semibold text-emerald-600">
                  Reminder
                </span>
              ) : (
                <span className="inline-flex h-7 items-center justify-center rounded-full border border-red-200 bg-red-50 px-2.5 text-[11px] font-semibold text-red-600">
                  Expired
                </span>
              )}
            </div>
          );
        } else {
          return <div className="h-7 w-[70px]" />;
        }
      },
    },
    {
      headerName: "Source",
      field: "source",
      minWidth: 150,
      renderCell: (params: YhTableCellParams) => {
        const source = params.row?.source || "—";
        const initial = String(source).trim().charAt(0).toUpperCase() || "?";
        const sourceColors = [
          "#A02448",
          "#3B82F6",
          "#14B8A6",
          "#F59E0B",
          "#EF4444",
          "#1E3A8A",
        ];
        let hash = 0;
        for (let i = 0; i < String(source).length; i++) {
          hash = String(source).charCodeAt(i) + ((hash << 5) - hash);
        }
        const bg = sourceColors[Math.abs(hash) % sourceColors.length];
        return (
          <div className="flex items-center gap-2.5">
            <span
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white"
              style={{ backgroundColor: bg }}
            >
              {initial}
            </span>
            <span className="truncate text-sm font-medium capitalize text-[#374151]">
              {source}
            </span>
          </div>
        );
      },
    },
    {
      headerName: "Stage",
      field: "stage",
      minWidth: 130,
      renderCell: (params: YhTableCellParams) => (
        <button
          type="button"
          className="action-button inline-flex h-8 items-center rounded-full border border-orange-300 bg-orange-50 px-3 text-xs font-semibold capitalize text-orange-600 transition hover:bg-orange-100 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={() => {
            setOpenModal({
              name: "Stage Details",
              data: {
                stage: params?.row?.AssignToUserStage,
                members: params.row?.AssignToUser,
              },
              open: true,
            });
          }}
          data-action-button="true"
          disabled={!params?.row?.AssignToUserStage?.length}
        >
          Stages
        </button>
      ),
    },
    {
      headerName: "Assigned To",
      field: "at",
      minWidth: 150,
      renderCell: (params: YhTableCellParams) => {
        const members = params.row?.AssignToUser || [];
        const count = params.row?.AssignTo?.length || members.length || 0;
        const shown = members.slice(0, 2);
        return (
          <button
            type="button"
            className="action-button flex items-center gap-2 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => {
              setOpenModal({
                name: "Assigne-To",
                data: {
                  team: params.row?.AssignTo,
                  members: params.row?.AssignToUser,
                },
                open: true,
              });
            }}
            data-action-button="true"
            disabled={!members.length}
          >
            <span className="flex h-7 min-w-[28px] items-center justify-center rounded-full bg-[#F9F0F4] px-1.5 text-xs font-bold text-[#A02448]">
              {count}
            </span>
            <span className="flex -space-x-2">
              {shown.map((m: any, i: number) => {
                const label =
                  m?.fullName || m?.name || m?.userName || m?.email || "?";
                const ch = String(label).charAt(0).toUpperCase();
                return (
                  <span
                    key={m?._id || m?.id || i}
                    className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-white text-[10px] font-bold text-white"
                    style={{
                      backgroundColor: ["#A02448", "#14B8A6", "#F59E0B"][i % 3],
                    }}
                    title={label}
                  >
                    {ch}
                  </span>
                );
              })}
            </span>
          </button>
        );
      },
    },
    {
      headerName: "Created Date",
      field: "date",
      minWidth: 130,
      renderCell: (params) => {
        let dateValue = params.value;

        if (typeof dateValue === "string" && /^\d{2}-\d{2}-\d{4}T/.test(dateValue)) {
          const [datePart, timePart] = dateValue.split("T");
          const [day, month, year] = datePart.split("-");
          dateValue = `${year}-${month}-${day}T${timePart}`;
        }

        const date = new Date(dateValue);

        const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "-");
        const formattedTime = date.toLocaleTimeString("en-IN", {
          timeZone: "Asia/Kolkata",
          hour: "2-digit",
          minute: "2-digit",
        });

        return (
          <div className="flex flex-col gap-0.5 text-xs leading-snug text-[#6B7280]">
            <div className="font-medium text-[#111827]">{formattedDate}</div>
            <div>{formattedTime}</div>
          </div>
        );
      },
    },
    {
      headerName: "Updated Date",
      field: "updatedAt",
      minWidth: 130,
      renderCell: (params) => {
        const formattedDate = new Date(params.value)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");
        const formattedTime = new Date(params.value).toLocaleTimeString(
          "en-IN",
          {
            timeZone: "Asia/Kolkata",
            hour: "2-digit",
            minute: "2-digit",
          }
        );
        return (
          <div className="flex flex-col gap-0.5 text-xs leading-snug text-[#6B7280]">
            <div className="font-medium text-[#111827]">{formattedDate}</div>
            <div>{formattedTime}</div>
          </div>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      minWidth: 80,
      renderCell: (params: YhTableCellParams) => (
        <button
          type="button"
          className="action-button flex h-8 w-8 items-center justify-center rounded-xl text-[#6B7280] transition-colors hover:bg-[#F3F4F6] hover:text-[#111827]"
          onClick={(event) => {
            event.stopPropagation();
            const rect = event.currentTarget.getBoundingClientRect();
            setMenuPosition({ top: rect.bottom, left: rect.left });
            setSelectedRow(params.row);
          }}
          data-action-button="true"
        >
          <VerticalDotIcon />
        </button>
      ),
    },
  ];

  const handleAutocompleteChange = async (
    name: string,
    value: any,
    data: any
  ) => {
    if (!name) return;

    switch (name) {
      case "stage": {

        const body = {
          ["id"]: data?._id,
          ["stage"]: value,
        };
        try {
          setApiResponse(true);
          const response = await changeStage(body);
          // setStageResponse(response)
          tableDataShowHandler();
          if (response.success === 1) {
            setShowSideBar(showSideBar);
            openSuccessNotification(response?.message);
          }
          setApiResponse(false);
        } catch (error: any) {
          setApiResponse(false);
          openErrorNotification(error.message || notifiers.GENERIC_ERROR);
        }
        break;
      }

      case "assignTo": {
        const body = { id: data?._id, AssignTo: value?.id };
        try {
          setApiResponse(true);
          await changeAt(body);
          tableDataShowHandler();
        } catch (error: any) {
          setApiResponse(false);
          openErrorNotification(error.message || notifiers.GENERIC_ERROR);
        }
        break;
      }

      case "formName": {
        if (!value || value.label === "All") {
          tableDataShowHandler();
          return;
        }

        const filteredData = response.filter((e: any) => e.formId === value.id);

        const transformedData = filteredData.map((userData: any) => ({
          lead: (
            <>
              <span className="font-yh-bold text-xs text-yh-black">{userData.uid}</span>
              <span className="font-yh-bold text-xs text-yh-black">
                {userData.leadName}
              </span>
            </>
          ),
          // reminder: <>{getReminderInfo(userData._id)}</>,
          property: (
            <span className="text-[11px] text-yh-black">
              {userData.projecttypeId}
            </span>
          ),
          contact: (
            <span className="text-[11px] text-yh-black">
              {userData.leadEmail}, {userData.leadPhone}
            </span>
          ),
          formName: (
            <span className="text-[11px] text-yh-black">
              {userData.form_name}
            </span>
          ),
          source: (
            <span className="text-[11px] text-yh-black">
              {userData.source}
            </span>
          ),
          stage: (
            <select
              className="yh-input h-9 text-xs"
              value={userData.stage || ""}
              onChange={(event) =>
                handleAutocompleteChange("stage", event.target.value, userData)
              }
            >
              <option value="" disabled>
                Select stage
              </option>
              {stageData.map((s: string) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          ),
          at: (
            <>
              {(userData.AssignTo || [])?.map((item: any) => (
                <span key={item.team_id} className="block text-xs text-yh-black">{item.team_name}</span>
              ))}
              {(userData.AssignToUser || [])?.map((item: any) => (
                <span key={item.user_id} className="block text-xs text-yh-black">{item.name}</span>
              ))}
            </>
          ),
          action: (
            <button
              type="button"
              className="flex h-8 w-8 items-center justify-center rounded-yh-md text-yh-black hover:bg-yh-lilac"
              onClick={(event) =>
                handlePopOver(
                  event,
                  userData.formId,
                  userData.status,
                  userData
                )
              }
            >
              <VerticalDotIcon />
            </button>
          ),
        }));
        setUserDataSource(transformedData);
        setUserDataSource1(filteredData);

        setApiResponse(false);
        setLoading(false);
        break;
      }

      default:
        console.warn("Unhandled case in handleAutocompleteChange");
    }
  };
  const handelSideSave = async (body: any) => {
    try {
      setApiResponse(true);
      const response = await saveReminder(body);
      if (response.success === 1) {
        const response5 = await getReminderData();
        setRemData(
          response5.data.map((e: any) => {
            return e;
          })
        );
        // const res = await getReminder(dynamicGridValue.row?._id)
        if (response.success === 1) {
          // const response5 = await getReminderData();
          const response5 = await getReminder(body.leadId);

          setReminders((prev) => ({
            ...prev,
            [body.leadId]: response5.data, // Ensure the new reminder follows { [id]: reminderData }
          }));
          tableDataShowHandler();
        }

        // setResponseValuereminder((prevFormData: any) => ({
        //   ...prevFormData,
        //   value: res?.data,
        // }));
      }
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handelAssignToUser = async (dynamicGridValue: any) => {
    try {
      if (selectedOptionsMembers?.length) {

        const idMembers = selectedOptionsMembers.map((item: any) => item.id);
        const body = {
          ["id"]: dynamicGridValue?._id,
          ["AssignToUser"]: idMembers.join(","),
        };
        const response = await assignToMembers(body);
        setIdForMember([]);
        setIdForTeam([]);

        tableDataShowHandler();
      } else {
        const idTeam = selectedOptions.map((item: any) => {
          return item.id;
        });
        const idTeamVal = idTeam.reduce(
          (val: any, item: any) => val + "," + `'${item}'`
        );
        const body1 = {
          ["id"]: dynamicGridValue.row?._id,
          ["AssignTo"]: idTeamVal,
        };
        const response2 = await changeAt(body1);
        setIdForMember([]);
        setIdForTeam([]);
        setSelectedOptionsMembers([]);
        setSelectedOptions([]);
        setLeadOptionMembersas([]);
        tableDataShowHandler();
      }
    } catch (error: any) { }
  };

  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      setLoading(true);

      const payload = {
        userId: store.getState().auth.userId,
        // team_id: offialDetailState.team_id?.id || "",
        pageNo: paginationModel.page,
        pageSize: paginationModel.pageSize,
        search: search || "",
        stage: stage?.label || "",
        source: source || "",
        formId: formLead.length > 0 ? formLead.join(",") : "",
        startDate: selectedDateRange?.from ? selectedDateRange?.from : "",
        endDate: selectedDateRange?.to ? selectedDateRange?.to : "",
      };
      const response = await getAllUsers(payload);
      setResponse(response.data);
      setMetaData(response?.metadata[0] ? response?.metadata[0] : []);
      setLoading(false);
      const tabelData = response.data.map((userData: any, index: any) => {
        return {
          lead: (
            <>
              <span className="block font-yh-bold text-xs text-yh-black">
                {userData?.leadName}
              </span>
              <span className="block font-yh-bold text-xs text-yh-black">{userData?.uid}</span>
            </>
          ),
          property: (
            <>
              <span className="text-[11px] text-yh-black">
                {userData.projecttypeId}
              </span>
            </>
          ),
          contact: (
            <span className="text-[11px] text-yh-black">
              {userData.leadEmail},{userData.leadPhone} <br />{" "}
              {userData.leadPhone}{" "}
            </span>
          ),
          formName: (
            <span className="text-[11px] text-yh-black">
              {userData?.form_name}
            </span>
          ),
          source: (
            <>
              <span className="text-[11px] text-yh-black">
                {userData?.source}
              </span>
            </>
          ),
          stage: <>{userData.AssignToUserStage}</>,
          at: (
            <>
              {(userData?.AssignTo || [])?.length &&
                (userData?.AssignTo || [])?.map((item: any) => {
                  <span key={item.team_id}>{item.team_name}</span>;
                })}
            </>
          ),
          action: (
            <>
              <button
                type="button"
                className="flex h-8 w-8 items-center justify-center rounded-yh-md text-yh-black hover:bg-yh-lilac"
                onClick={(event: any) =>
                  handlePopOver(
                    event,
                    userData.formId,
                    userData.status,
                    userData
                  )
                }
              >
                <VerticalDotIcon />
              </button>
            </>
          ),
        };
      });
      const arr = new Array(20);
      setUserDataSource([...tabelData]);
      const source1 = response.data.map((userData: any) => {
        return userData;
      });
      const filteredLeadData = source1
        .filter((data: any) => data.status === "0")
        .sort((a: any, b: any) => Number(b.priority) - Number(a.priority));

      setUserDataSource1([...filteredLeadData]);

      setApiResponse(false);
      setLoading(false);
    } catch (error: any) {
      setApiResponse(false);
      setLoading(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleChangeRadio = (event: any) => {
    setReminderStatus(event.target.value || event.target.defaultValue);
  };
  const handleCloseAddTeam = () => {
    setNewTeamDialog(false);
    tableDataShowHandler();
  };


  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <div className="mr-3 mt-1 cursor-pointer">
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </div>
    );
  };

  const dialogTitleContent = () => {
    return (
      <div className="px-[70px]">
        <div>
          <h2 className="font-yh-bold text-lg text-yh-black">Account Status</h2>
          <p className="mt-1 text-xs text-yh-light-gray">
            Change your account status
          </p>
        </div>

        <div className="mt-5">
          <p className="font-yh-bold text-sm text-yh-black">Current Status</p>

          <div className="mt-2.5 flex items-center gap-4">
            <CustomRadioButton
              value={1}
              checked={selectedUser.status == 1}
              onChange={handleRadioChange}
              label="Active"
            />

            <CustomRadioButton
              value={0}
              checked={selectedUser.status == 0}
              onChange={handleRadioChange}
              label="Deactive"
            />
          </div>
          <div>
            <CustomButton
              onClick={() => { }}
              label="Delete Account"
              buttonType="iconBtn"
              customClasses={{ color: "red" }}
            />
          </div>
        </div>
        <div className="flex w-[350px] justify-start gap-2.5">
          <CustomButton
            label="Save"
            onClick={() => { }}
            buttonType="primaryBtn"
          />
          <CustomButton
            label="Cancel"
            onClick={() => {
              setIsDialogOpen(false);
            }}
            buttonType="secondaryBtn"
          />
        </div>
      </div>
    );
  };

  const handelDropdownAfterSelect = async (ids: any, id: any = null) => {
    try {
      const payload = {
        team_id: ids,
        lead_id: id?.id,
      };
      const response1 = await getAllTeamMembersData(payload);
      const data =
        response1.data.flatMap((member: any) => {
          return (member?.team_members || []).map((mem: any) => {
            if (!mem.users || !mem.users[0]) return null;
            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          }).filter(Boolean);
        })

      setLeadOptionMembersas(data);
      const members = response1.data
        .flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]?._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
        .filter((item: any) => item.selected === 1);

      setSelectedOptionsMembers(members);
    } catch { }
  };
  const handleOptionCheckboxChange =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        const ids = [option.id, ...selectedOptions.map((e: any) => e.id)];
        handelDropdownAfterSelect(ids);
        setIdForTeam((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        setLeadOption((prev: any) => [...leadOption]);
        if (option.teamMembers) {
          setLeadOptionMembersas((prev: any) => {
            return [
              ...prev,

              ...option.teamMembers.map((member: any) => {
                return {
                  pId: option.id,
                  id: member.id,
                  label: member.label,
                  selected: 0,
                };
              }),
            ];
          });
        }
        setSelectedOptions([...selectedOptions, opt]);
      } else {
        setSelectedOptions(
          selectedOptions.filter((item: any) => item.id !== option.id)
        );
        setLeadOptionMembersas(
          leadOptionMembers.filter((item: any) => item?.pId !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        setLeadOption((prev: any) => [...leadOption]);
        setIdForTeam(idForTeam.filter((item: any) => item !== option?.id));
      }
    };
  const handleOptionCheckboxChange1 =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        setIdForMember((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setSelectedOptionsMembers([...selectedOptionsMembers, opt]);
      } else {
        setSelectedOptionsMembers(
          selectedOptionsMembers.filter((item: any) => item.id !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setIdForMember(idForMember.filter((item: any) => item !== option?.id));
      }
    };
  const handleAssignToMember = (option: any, isChecked: boolean) => {
    const updatedOption = { ...option, selected: isChecked ? 1 : 0 };

    // Update the leadOptionMembers state immutably
    const updatedLeadOptions = leadOptionMembers.map((item: any) =>
      item.id === option.id ? updatedOption : item
    );

    setLeadOptionMembersas(updatedLeadOptions);

    // Update selected options
    const updatedSelectedOptions = isChecked
      ? [...selectedOptionsMembers, updatedOption]
      : selectedOptionsMembers.filter((item: any) => item.id !== option.id);

    setSelectedOptionsMembers(updatedSelectedOptions);

    // Update the idForMember array
    const updatedIdForMember = isChecked
      ? [...idForMember, option.id]
      : idForMember.filter((id: any) => id !== option.id);

    setIdForMember(updatedIdForMember);
  };

  const handleDateTimeChange = (event: any) => {
    const selectedDateTime = event.target.value;
    setReminderData((prevFormDataFields: any) => ({
      ...prevFormDataFields,
      ["date"]: event.target.value.split("T")[0],
      ["time"]: event.target.value.split("T")[1],
    }));
  };

  const handleSearch = async (newValue: string) => {
    setSearch(newValue);
    setLoading(false);

  };

  const handleChange = (value: any) => {
    setPaginationModel({
      pageSize: value.target.value,
      page: 0,
    });
  };
  const getRemarkInfo = async (id: any) => {
    try {
      setApiResponse(true);
      const response = await getRemark(id);
      if (response.success == 1) {
        setResponseValueremark((prevFormData: any) => ({
          ...prevFormData,

          value: response?.data,
        }));
      } else {
        setResponseValueremark([]);
      }
    } catch (error: any) {
      // openErrorNotification(
      //   isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      // );
    } finally {
      setApiResponse(false);
    }
  };
  const handelSideSaveRemark = async (body: any) => {
    const payloade = {
      leadId: body.leadId,
      notes: body.notes_remark,
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString(),
      title: "",
    };
    try {
      setApiResponse(true);
      const response = await saveRemark(payloade);
      if (response.success === 1) {
        // setDynamicGridValue("");
        setReminderData((prevData: any) => ({
          ...prevData,
          notes_remark: "",
        }));
      }
      getRemarkInfo(body.leadId);
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handelRemoveReminder = async (item: any) => {
    try {
      setApiResponse(true);
      const response = await deleteReminder(item);
      if ((response.sucess = 1)) {
      }
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const importLeadExcelFile = async () => {
    try {
      setdownloadLoading(true)
      const payload = {
        startDate: selectedDateRange?.from ? selectedDateRange?.from : "",
        endDate: selectedDateRange?.to ? selectedDateRange?.to : "",
        formId: formLead.length > 0 ? formLead.join(",") : "",
      }
      const resExcle = await getDownloadLeadsExcle(payload);
      if (resExcle.success && resExcle.fileData && resExcle.filename) {
        const byteCharacters = atob(resExcle.fileData);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = resExcle.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Invalid response structure:", resExcle);
      }
    } catch (err) {
      setdownloadLoading(false)
      console.error("Error downloading Excel file:", err);
    }
    finally {
      setdownloadLoading(false)

    }
  };


  const isFormAllSelected = tableData.length > 0 && tableData.length === formName.length;

  const outlineBtnClass =
    "inline-flex h-10 shrink-0 items-center gap-2 rounded-xl border border-[#E5E7EB] bg-white px-3.5 text-sm font-medium text-[#374151] transition hover:border-[#D4B8C0] hover:bg-[#F8FAFC]";
  const filterBtnClass =
    "flex h-10 w-full items-center justify-between rounded-xl border border-[#E5E7EB] bg-white px-3 text-left text-xs text-[#374151] outline-none transition hover:border-[#D4B8C0] focus:border-[#A02448]";
  const filterMenuClass =
    "absolute right-0 z-30 mt-1 max-h-60 w-full min-w-[180px] overflow-auto rounded-xl border border-[#E5E7EB] bg-white py-1 shadow-[0_8px_24px_rgba(15,23,42,0.08)]";

  const clearAllFilters = () => {
    setSource(null);
    setStage(null);
    setTableData([]);
    filterLeadByForm([]);
    setSelectedDateRange({ from: null, to: null });
    setSearch("");
  };

  const totalLeads = Number(userDataSource1?.length || 0);
  const pageRows = userDataSource1 || [];
  const countByStageHint = (hints: string[]) =>
    pageRows.filter((row: any) => {
      const stages = Array.isArray(row?.AssignToUserStage)
        ? row.AssignToUserStage.join(" ").toLowerCase()
        : String(row?.AssignToUserStage || row?.stage || "").toLowerCase();
      return hints.some((h) => stages.includes(h));
    }).length;

  const getShowAllPage = () => {
    return (
      <>
        <div className="flex h-full min-h-0 w-full flex-col">
          {/* Page header */}
          <div className="mb-4 flex shrink-0 flex-wrap items-start justify-between gap-4">
            <div>
              <h3 className="text-xl font-bold tracking-tight text-[#111827]">
                Archive Leads
              </h3>
              <p className="mt-1 text-sm text-[#6B7280]">
                View &amp; manage all the leads your company has archived.
              </p>
            </div>
          </div>

          {/* KPI summary cards */}
          <div className="mb-4 grid shrink-0 grid-cols-2 gap-3 xl:grid-cols-5">
            <LeadStatCard
              title="Total Leads"
              value={totalLeads}
              accent="purple"
              icon={<UsersIcon size={20} />}
              loading={loading}
            />
            <LeadStatCard
              title="New Leads"
              value={countByStageHint(["new", "initial", "contact"])}
              accent="blue"
              icon={<UserAddIcon size={20} />}
              loading={loading}
            />
            <LeadStatCard
              title="In Progress"
              value={countByStageHint([
                "prospect",
                "opportunity",
                "follow",
                "progress",
                "lead",
              ])}
              accent="orange"
              icon={<ClockIcon size={20} />}
              loading={loading}
            />
            <LeadStatCard
              title="Converted"
              value={countByStageHint(["closure", "won", "convert", "booked"])}
              accent="green"
              icon={<CheckIconRi size={20} />}
              loading={loading}
            />
            <LeadStatCard
              title="Lost Leads"
              value={countByStageHint(["lost", "dead", "reject"])}
              accent="red"
              icon={<XCircleIcon size={20} />}
              loading={loading}
            />
          </div>

          {/* Search left + two filters only */}
          <div
            id="all-leads-filters"
            className="mb-3 flex shrink-0 flex-wrap items-center justify-between gap-3"
          >
            <div className="min-w-[240px] flex-1 sm:max-w-[420px]">
              <YhInput
                placeholder="Search by Id, Name, Email and Phone"
                value={search}
                type="search"
                id="outlined-search"
                onChange={(e) => handleSearch(e.target.value)}
                autoFocus={isSearchFocused}
                startAdornment={<SearchSvg />}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                containerClassName="w-full max-w-[420px]"
              />
            </div>

            <div className="flex flex-wrap items-center justify-end gap-2.5">
              <span className="text-xs font-medium text-[#6B7280]">Filters</span>

              {/* Form / project select */}
              <div className="relative w-[180px]" ref={formMenuRef}>
                <button
                  type="button"
                  onClick={() => {
                    loadArchiveCatalogs();
                    setFormMenuOpen((o) => !o);
                  }}
                  className={filterBtnClass}
                >
                  <span className="truncate">
                    {tableData.length === 1
                      ? tableData[0]?.label || "All"
                      : isFormAllSelected || tableData.length === 0
                        ? "All"
                        : `${tableData.length} selected`}
                  </span>
                  <ChevronSvg />
                </button>
                {formMenuOpen && (
                  <div className={filterMenuClass}>
                    {[{ label: "All", id: "all" }, ...formName].map((option: any) => {
                      const checked =
                        option.id === "all"
                          ? isFormAllSelected || tableData.length === 0
                          : tableData.some((t: any) => t.id === option.id);
                      return (
                        <button
                          key={option.id}
                          type="button"
                          className={`block w-full px-3 py-2 text-left text-xs ${
                            checked
                              ? "bg-[#A02448] font-medium text-white"
                              : "text-[#111827] hover:bg-[#F8FAFC]"
                          }`}
                          onClick={() => {
                            if (option.id === "all") {
                              setTableData([]);
                              filterLeadByForm([]);
                              setFormMenuOpen(false);
                              return;
                            }
                            setTableData([option]);
                            filterLeadByForm([option.id]);
                            setFormMenuOpen(false);
                          }}
                        >
                          {option.label}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>

              {/* Date range */}
              <div className="relative w-[220px]" ref={dateMenuRef}>
                <button
                  type="button"
                  onClick={() => setOpenDatePicker((o) => !o)}
                  className={filterBtnClass}
                >
                  <span
                    className={`truncate ${
                      selectedDateRange?.from && selectedDateRange?.to
                        ? "text-[#111827]"
                        : "text-[#9CA3AF]"
                    }`}
                  >
                    {selectedDateRange?.from && selectedDateRange?.to
                      ? `${selectedDateRange.from} - ${selectedDateRange.to}`
                      : "MM/DD/YYYY - MM/DD/YYYY"}
                  </span>
                  <ChevronSvg />
                </button>
                {openDatePicker && (
                  <div className={`${filterMenuClass} right-0 left-auto w-[200px]`}>
                    {shortcutsItems.map((item) => (
                      <button
                        key={item.label}
                        type="button"
                        className="block w-full px-3 py-2 text-left text-xs font-medium text-[#111827] hover:bg-[#F8FAFC] hover:text-[#A02448]"
                        onClick={() => handleDateRangeChange(item.getValue())}
                      >
                        {item.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="relative min-h-0 flex-1">
            {privileges &&
              (privileges?.["Archive Lead List"]?.includes("view") ||
                privileges?.["Archive Lead List"]?.includes("full control")) ? (
              <>
                <YhTable
                  columns={columns}
                  rows={userDataSource1}
                  getRowId={(row) => row._id}
                  rowHeight={80}
                  loading={loading}
                  emptyMessage="No data found"
                  className="h-full min-h-[280px]"
                  onRowClick={(row, e) => {
                    const targetElement = e.target as HTMLElement;
                    if (
                      targetElement?.classList?.contains("action-button") ||
                      targetElement?.closest?.(".action-button") ||
                      targetElement?.closest?.("[data-action-button]")
                    ) {
                      return;
                    }
                    handleRowClick({ row, id: row._id });
                  }}
                  page={paginationModel.page}
                  pageSize={paginationModel.pageSize}
                  totalRows={userDataSource1?.length || 0}
                  onPageChange={(p) => setPaginationModel({ ...paginationModel, page: p })}
                  onPageSizeChange={(s) => setPaginationModel({ pageSize: s, page: 0 })}
                />

                {renderMenu()}
              </>
            ) : (
              ""
            )}
            {anchorEl && (
              <>
                <div className="fixed inset-0 z-40" onClick={handleClose} />
                <div
                  ref={editPopoverRef}
                  className="fixed z-50 flex w-[140px] max-w-full flex-col items-start rounded-yh-md border border-yh-border bg-white p-1 shadow-yh"
                  style={{
                    top: anchorEl.getBoundingClientRect().bottom + 10,
                    left: Math.max(0, anchorEl.getBoundingClientRect().left - 20),
                  }}
                >
                  {privileges &&
                    (privileges?.["Archive Lead List"]?.includes("edit") ||
                      privileges?.["Archive Lead List"]?.includes("full control")) ? (
                    <CustomButton
                      label="Edit"
                      buttonType="iconBtn"
                      onClick={() => {
                        handleEdit(userRow_Id ?? "");
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}
          </div>
          {addNewTeamDialog?.open && ( // modal for add new new lead
            <AddNewTeam
              isDialogOpen={true}
              handleCloseAddTeam={handleCloseAddTeam}
              userId={userId}
              setUserId={setUserId}
              addNewTeamDialog={addNewTeamDialog}
              eventForEdit={eventForEdit}
            />
          )}

          {customerDetails?.open && (
            <AddNewTeam2
              isDialogOpen={true}
              handleCloseAddTeam={closeHandler}
              userId={userId}
              setUserId={setUserId}
              addNewTeamDialog={addNewTeamDialog}
              eventForEdit={eventForEdit}
              leadData={leadData}
              stageData={stageData}
              formName={formName}
              stageSourse={stageSourse}
              responseValuereminder={responseValuereminder}
              responseValueremark={responseValueremark}
              selectedOptions={selectedOptions}
              leadOption={leadOption}
              type={type}
              allSatgedata={allSatgedata}
              addinationalValue={addinationalValue}
            />
          )}
          {apiResponse && <CustomLoader apiResponse={false} />}
        </div>
        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {/* {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}

        {isDialogOpenLoanList && (
          <LoanList
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoanList}
            userId={userId}
            status={status}
          />
        )} */}
      </>
    );
  };

  return (
    <>
      <div className="flex h-full min-h-0 w-full gap-0 overflow-hidden">
        {/* Main table area — shrinks when drawer opens */}
        <div
          className={`h-full min-h-0 min-w-0 transition-[flex-basis,width,margin] duration-300 ease-in-out ${
            dynamicGridValue
              ? "w-full flex-[1_1_0%] pr-0 md:pr-3"
              : "w-full flex-[1_1_100%]"
          }`}
        >
          {getShowAllPage()}
        </div>

        {/* Side drawer — pushes in from the right */}
        <aside
          aria-hidden={!dynamicGridValue}
          className={`relative h-full shrink-0 overflow-hidden transition-[width,opacity] duration-300 ease-in-out ${
            dynamicGridValue
              ? "w-[280px] opacity-100 sm:w-[300px] xl:w-[340px]"
              : "pointer-events-none w-0 opacity-0"
          }`}
        >
          <div
            className={`relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#EEF0F5] bg-white shadow-[0_4px_20px_rgba(15,23,42,0.06)] transition-transform duration-300 ease-in-out ${
              dynamicGridValue ? "translate-x-0" : "translate-x-full"
            }`}
            style={{ width: "100%", minWidth: dynamicGridValue ? undefined : 0 }}
          >
            <button
              type="button"
              className="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-xl border border-[#E5E7EB] bg-white text-[#374151] shadow-sm transition hover:bg-[#F3F4F6]"
              onClick={() => {
                setReminderStatus("");
                setDynamicGridValue("");
                setShowSideBar(false);
              }}
              aria-label="Close lead details"
            >
              <CloseIcon width={"12px"} height={"12px"} />
            </button>

            <div className="h-full w-full overflow-auto p-4 pt-12 [scrollbar-width:thin] [scroll-padding-bottom:96px] sm:min-w-[300px] xl:min-w-[340px]">
              {dynamicGridValue ? (
                <LeadDetailsComponent
                  dynamicGridValue={dynamicGridValue}
                  handleAutocompleteChange={handleAutocompleteChange}
                  handleOptionCheckboxChange={handleOptionCheckboxChange}
                  selectedOptions={selectedOptions}
                  leadOption={leadOption}
                  leadOptionMembers={leadOptionMembers}
                  handleOptionCheckboxChange1={handleOptionCheckboxChange1}
                  handleAssignToMember={handleAssignToMember}
                  selectedOptionsMembers={selectedOptionsMembers}
                  handleChangeRadio={handleChangeRadio}
                  reminderStatus={reminderStatus}
                  setReminderStatus={setReminderStatus}
                  setReminderData={setReminderData}
                  currentDateTime={currentDateTime}
                  handleDateTimeChange={handleDateTimeChange}
                  handelAssignToUser={handelAssignToUser}
                  handelSideSave={handelSideSave}
                  reminderData={reminderData}
                  responseValuereminder={responseValuereminder}
                  addinationalValue={addinationalValue}
                  stageData={stageData}
                  isMyLead={false}
                  responseValueremark={responseValueremark}
                  handelSideSaveRemark={handelSideSaveRemark}
                  handelRemoveReminder={handelRemoveReminder}
                  onRemindersChange={(rows: any[]) => {
                    setResponseValuereminder({ value: rows });
                  }}
                  openCustomer={openCustomer}
                  setLeadData={setLeadData}
                  allSatgedata={allSatgedata}
                />
              ) : null}
            </div>
          </div>
        </aside>

        <YhModal
          open={openModal.open}
          onClose={handleCloseModal}
          width={700}
          title={
            openModal.name === "Stage Details"
              ? "Stage Details"
              : openModal.name === "Reminder"
                ? "Reminder"
                : "Team List"
          }
        >
          {openModal.name === "Stage Details" ? (
            <div className="max-h-[275px] overflow-auto">
              <table className="w-full border-collapse text-left">
                <thead className="sticky top-0 bg-white">
                  <tr>
                    <th className="w-3/4 border-b border-yh-border-light px-1 py-1 text-sm font-yh-bold text-yh-black">
                      Name
                    </th>
                    <th className="w-1/4 border-b border-yh-border-light px-1 py-1 text-sm font-yh-bold text-yh-black">
                      Stage
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {openModal?.data?.stage
                    ?.filter((item: any) =>
                      openModal?.data?.members.some(
                        (e: any) => e._id === item.user_id
                      )
                    )
                    .map((item: any, index: number) => (
                      <tr key={index} className="border-b border-yh-border-light">
                        <td className="px-1 py-1 text-xs text-yh-black">
                          {(() => {
                            const member = openModal?.data?.members.find(
                              (e: any) => e._id === item.user_id
                            );
                            return member ? (
                              <>
                                {member.name} (
                                {hierarchyMap[member.hierarchyId] || ""})
                              </>
                            ) : (
                              ""
                            );
                          })()}
                        </td>

                        <td className="px-1 py-2 text-xs text-yh-black">
                          {item.stage?.charAt(0).toUpperCase() +
                            item.stage?.slice(1) || "New"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          ) : openModal.name === "Reminder" ? (
            <div />
          ) : (
            <div className="max-h-[300px] overflow-auto">
              <table className="w-full border-collapse text-left">
                <thead className="sticky top-0 bg-white">
                  <tr>
                    <th className="w-1/2 border-b border-yh-border-light px-2 py-2 text-sm font-yh-bold text-yh-black">
                      Team Name
                    </th>
                    <th className="w-1/2 border-b border-yh-border-light px-3 py-2 text-base font-yh-bold text-yh-black">
                      Team Members
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {openModal?.data?.team?.map((item: any, index: number) => (
                    <tr key={index} className="border-b border-yh-border-light">
                      <td className="px-3 py-3 text-xs text-yh-black">
                        {item.team_name}
                      </td>
                      <td className="px-3 py-3 text-sm text-yh-black">
                        {openModal?.data?.members
                          ?.filter((member: any) => {
                            const teamIdArray = JSON.parse(member.team_id);
                            return (
                              Array.isArray(teamIdArray) &&
                              teamIdArray.includes(item._id)
                            );
                          })
                          ?.map((member: any, idx: number) => (
                            <div key={idx} className="mb-1 p-1">
                              {member.name} (
                              {hierarchyMap[member.hierarchyId] || ""})
                            </div>
                          ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </YhModal>
      </div>
    </>
  );
};

export default ShowAll;
